import { render, staticRenderFns } from "./calendario.vue?vue&type=template&id=68ca0302&"
import script from "./calendario.vue?vue&type=script&lang=js&"
export * from "./calendario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports